import React from 'react';
import { ErrorBoundary } from 'wsm-error-boundary';
import Reviews from '../components/Reviews';
import Footer from '../components/Footer';
import IconAndRatings from '../components/IconAndRatings';

const WidgetContainer = () => {
	return (
		<ErrorBoundary newRelicPageAction="WS DETAILED KBB REVIEWS ERROR BOUNDARY">
			<>
				<IconAndRatings />
				<Reviews />
				<Footer />
			</>
		</ErrorBoundary>
	);
};

export default WidgetContainer;
